import { useQuery } from "@tanstack/react-query";
import { getExpiringTaxForm } from "./rest/taxForms";
import { ExpiringTaxForm } from "../types/expiringTaxForm.interface";

const useExpiringTaxFormQuery = (enabled: boolean) => {
  const { data, isLoading } = useQuery<ExpiringTaxForm>({
    queryKey: ["expiring-tax-form"],
    queryFn: getExpiringTaxForm,
    retry: false,
    enabled,
  });

  return { expiringTaxForm: data, isLoading };
};

export default useExpiringTaxFormQuery;
